<template>
    <div class="faciliti">
        <div class="faciliti__container">
            <a href="https://ws.facil-iti.com" target="_blank" rel="nofollow noopener noreferrer">
                <div class="faciliti__text">Votre site + facile d'accès</div>
                <!-- @formatter:off -->
                <!-- eslint-ignore -->
                <svg xmlns="http://www.w3.org/2000/svg" height="35" aria-hidden="true"
                     viewBox="0 0 300 90"
                ><circle cx="45" cy="45" r="45"
                         class="st0"
                /><path fill="#020203" d="M26.3 59.7l29.7 29C74.8 84 89 67.5 90 47.5L78.4 36.1 26.3 59.7z" opacity=".2" /><polygon points="77.5,34.3 55,39.3 57.5,42.4" class="st2" /><polygon points="12.8,34.2 35.3,39.3 32.8,42.3" class="st2" /><polygon points="45.3,47.5 55.4,43.3 45.3,27.7 45.3,27.7 45.3,27.7 45.3,27.7 45.3,27.7 34.8,43.2 45.3,47.5 45.3,47.6 45.3,47.5 45.3,47.6" class="st2" /><polygon points="45.3,50 12.2,36.1 26.3,59.7 45.3,59.7 45.3,59.7 64.3,59.7 78.4,36.1" class="st2" /><g><path d="M235 27.7V11.1h8.6L235 27.7z" class="st0" /><path d="M138.2 18.9h-15.6v23.5h9.9V50h-9.9v28.6H115V11.3h23.2v7.6zM164.9 78.6h-7.7l-1-8.3h-9.6l-1 8.3h-8L148 11.4h6.8l10.1 67.2zm-9.6-15.5l-3.8-29.4-3.9 29.4h7.7zM196.6 66.7c0 1.8-.3 3.5-1 5.1-.7 1.6-1.6 3-2.8 4.2-1.2 1.2-2.6 2.1-4.2 2.8-1.6.7-3.3 1-5.1 1-1.8 0-3.5-.3-5.1-1-1.6-.7-3-1.6-4.2-2.8-1.2-1.2-2.1-2.6-2.8-4.2-.7-1.6-1-3.3-1-5.1V23.3c0-1.8.3-3.5 1-5.1.7-1.6 1.6-3 2.8-4.2 1.2-1.2 2.6-2.1 4.2-2.8 1.6-.7 3.3-1 5.1-1 1.8 0 3.5.3 5.1 1 1.6.7 3 1.6 4.2 2.8 1.2 1.2 2.1 2.6 2.8 4.2.7 1.6 1 3.3 1 5.1v2.2H189v-2.2c0-1.6-.5-2.9-1.6-3.9a5.28 5.28 0 00-3.9-1.6c-1.6 0-2.9.5-3.9 1.6a5.28 5.28 0 00-1.6 3.9v43.4c0 1.6.5 2.9 1.6 3.9 1.1 1.1 2.4 1.6 3.9 1.6s2.8-.5 3.9-1.6 1.6-2.4 1.6-3.9v-.8l7.6-2.5v3.3zM210.4 78.6h-7.6V11.3h7.6v67.3zM237.8 78.6h-20.5V11.3h7.6V71h12.9v7.6zM256.6 78.6H249V26.1h7.6v52.5zM278.5 72.3c.7 0 1.4-.2 2.1-.5.6-.3 1.1-.8 1.4-1.3l5.1 5.6c-.9 1.1-2.2 2-3.7 2.7-1.5.7-3.1 1-4.6 1-3.7 0-6.6-1.2-8.7-3.6s-3.1-5.5-3.1-9.3v-34h-4.8v-6.6h4.8v-9.5l7.6-2.5v12.1h10V33h-10v34c0 3.5 1.3 5.3 3.9 5.3zM299.7 78.6h-7.6V26.1h7.6v52.5z" class="st2" /><circle cx="253" cy="14.4" r="3.9"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   class="st2"
                /><circle cx="296.1" cy="14.4" r="3.9"
                          class="st2"
                /></g></svg>
                <!-- @formatter:on -->
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'LayoutFaciliti',
    };
</script>

<style lang="scss">
    @import '~@/assets/styles/abstracts/_variables';
    @import '~@/assets/styles/abstracts/_placeholders';
    @import '~@/assets/styles/abstracts/_mixins';

    .faciliti {
        display: none;
        background: $color-brand;
        border-top: 1px solid white;

        &__container {
            display: flex;
            padding: 0 3rem;

            @media screen and (min-width: map_get($grid-breakpoints, 'sm')) {
                justify-content: center;
            }
        }

        a {
            display: flex;
            align-items: center;

            font-weight: bold;
            color: white;

            &:hover,
            &:active,
            &:focus {
                text-decoration: underline;
                color: white;
            }
        }

        &__text {
            padding: 1.4rem 0;
            margin-right: 1.4rem;

            @media screen and (min-width: map_get($grid-breakpoints, 'sm')) {
                padding: 1.4rem 0;
            }
        }
    }

    svg {
        max-height: 2rem;

        .st0 {
            fill: #e2033c
        }

        .st2 {
            fill: #fff
        }

        @media screen and (min-width: map_get($grid-breakpoints, 'sm')) {
            max-height: 3.5rem;
        }
    }
</style>
